module.exports = {
    "collapse": `Contraer`,
    "expand": `Ampliar`
};


//# sourceMappingURL=es-ES.main.js.map
